"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCalendarDate = void 0;
function formatCalendarDate(date) {
    if (!date)
        return "";
    var year = date.year, month = date.month, day = date.day;
    return "".concat(year.toString().padStart(4, "0"), "-").concat(month.toString().padStart(2, "0"), "-").concat(day.toString().padStart(2, "0"));
}
exports.formatCalendarDate = formatCalendarDate;
